/**
 * Created by Administrador on 17/11/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('subClassificationSsrCtrl', subClassificationSsrCtrl);

    subClassificationSsrCtrl.$inject = ['linkService', 'tabs','subClassifications','fareSubClassifications'];

    function subClassificationSsrCtrl(linkService, tabs, subClassifications, fareSubClassifications){
        var vm = this;
        vm.tabs = tabs;
        vm.pages = subClassifications.data.page;
        vm.subClassifications = (subClassifications.data._embedded) ? subClassifications.data._embedded.ssrSubClassifications : [];
        vm.fareSubClassifications = (fareSubClassifications.data._embedded) ? fareSubClassifications.data._embedded.fareSubClassifications : [];
        vm.linkService = linkService;

        angular.forEach(vm.subClassifications, function(subClassification){
            angular.forEach(vm.fareSubClassifications, function(fareSubClassification){
                if(vm.linkService.getLinkId(fareSubClassification._embedded.subClassification._links.self.href)==
                    vm.linkService.getLinkId(subClassification._links.self.href)){
                    subClassification.fareClassification = fareSubClassification;
                }
            })
        });
    }
})();
